import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'OperationRecord',
    column_type: 'id',
  },
  created_at: {
    model_name: 'OperationRecord',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'OperationRecord',
    column_type: 'datetime',
  },
  operatable_type: {
    model_name: 'OperationRecord',
    column_type: 'string',
  },
  operatable: {
    model_name: 'OperationRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'operatable',
      model_name: '',
    },
  },
  operatable_id: {
    model_name: 'OperationRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'operatable',
      model_name: '',
    },
  },
  operator_type: {
    model_name: 'OperationRecord',
    column_type: 'string',
  },
  operator: {
    model_name: 'OperationRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'operator',
      model_name: '',
    },
  },
  operator_id: {
    model_name: 'OperationRecord',
    column_type: 'belongs_to',
    extra: {
      association_name: 'operator',
      model_name: '',
    },
  },
  ip_address: {
    model_name: 'OperationRecord',
    column_type: 'string',
  },
  operation_description: {
    model_name: 'OperationRecord',
    column_type: 'string',
  },
  request_path: {
    model_name: 'OperationRecord',
    column_type: 'string',
  },
  request_method: {
    model_name: 'OperationRecord',
    column_type: 'string',
  },
  request_params: {
    model_name: 'OperationRecord',
    column_type: 'string',
  },
  previous_object: {
    model_name: 'OperationRecord',
    column_type: 'string',
  },
  current_object: {
    model_name: 'OperationRecord',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
